export default __webpack_public_path__ + "static/media/srilanka.3b9e932f.svg";